<template>
  <div>
    <status-progressing-closed />
    <ts-card class="m-t-10">
      <div>
        <ts-card>
          <ts-card-wrapper>
            <div class="d-flex justify-content-between">
              <ts-button
                color="info"
                outline
                @click.prevent="$router.push({ name: 'homework-create' })"
                >{{ $t('add_new') }}</ts-button
              >
              <div class="d-flex">
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 250px;"
                  class="inline-block"
                />
                <ts-button
                  outline
                  class="ml-2"
                  v-tooltip="$t('invoice.filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
            <!-- drawer -->
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="onCloseDrawer"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="ts-text-xs">{{ $t('homework.date') }}</label>
                    <a-range-picker
                      format="DD-MM-YYYY"
                      :defaultValue="rangeDate"
                      :defaultPickerValue="rangeDate"
                      @change="dateRangeChange"
                    >
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="ts-text-xs">
                      {{ $t('homework.status') }}
                    </label>
                    <a-select
                      v-model="homework_status_id"
                      style="width:100%"
                      @change="fetchData"
                    >
                      <a-select-option :value="1">{{
                        $t('home.progressing')
                      }}</a-select-option>
                      <a-select-option :value="2">{{
                        $t('home.closed')
                      }}</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </a-drawer>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
              :rowGroup="{
                field: 'academic_class.branch.branch_name_en'
              }"
            >
              <template v-slot="{ record }">
                <td>{{ record.homework_date }}</td>
                <td>{{ record.class_name }}</td>
                <td>{{ record.subject_name }}</td>
                <td>{{ record.remarks }}</td>
                <td>
                  <span class="label label-success" v-if="record.is_sent"
                    >Sent</span
                  >
                  <span class="label label-info" v-else>{{
                    $t('home.pending')
                  }}</span>
                </td>
                <td>{{ record.sent_date }}</td>
                <td class="text-center">{{ record.student_homework_count }}</td>
                <td class="text-center">{{ record.input_score_count }}</td>
                <td class="text-left ts-whitespace-no-wrap">
                  <a-switch
                    size="small"
                    :checked="record.status_open"
                    @change="closeOpen(record)"
                    :loading="homework_status_loading"
                  />
                  <a
                    href="#"
                    class="text-primary ml-2"
                    @click.prevent="edit(record)"
                    v-if="!record.is_sent"
                    v-tooltip="$t('edit')"
                  >
                    <a-icon type="edit" />
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-primary"
                    v-tooltip="$t('homework.sendNotification')"
                    v-if="!record.is_sent && record.approve_status == 2"
                    @click="sendNotification(record)"
                  >
                    <i class="far fa-paper-plane"></i>
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-info"
                    v-tooltip="$t('homework.comment')"
                    v-if="record.is_sent"
                    @click.prevent="onComment(record)"
                  >
                    <a-icon type="message" />
                  </a>
                  <a
                    href="#"
                    class="text-primary"
                    v-tooltip="$t('homework.correction')"
                    v-if="record.is_sent"
                    @click.prevent="
                      $router.push({
                        name: 'homework-correction',
                        params: { id: record.homework_id }
                      })
                    "
                  >
                    <a-icon type="carry-out" />
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import StatusProgressingClosed from './status-progressing-closed'
import { Errors } from 'form-backend-validation'

export default {
  name: 'homework',
  components: {
    StatusProgressingClosed
  },
  data() {
    return {
      parentEdit: 0,
      studentEdit: 0,
      homeworkPending: 0,
      loading: false,
      homework_status_loading: false,
      visible: false,
      errors: new Errors(),
      rangeDate: [moment().add(-2, 'Month'), moment().add(1, 'Month')]
    }
  },
  computed: {
    ...mapState('home/teacherHomework', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.home.teacherHomework.search
      },
      set(newVal) {
        this.$store.commit('home/teacherHomework/SET_SEARCH', newVal)
        this.$store.commit('home/teacherHomework/RESET_CURRENT_PAGE')
      }
    },
    homework_status_id: {
      get() {
        return this.$store.state.home.teacherHomework.homework_status_id
      },
      set(newValue) {
        this.$store.commit('home/teacherHomework/SET_HOMEWORK_STATUS', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('homework.branch') },
        { name: this.$t('homework.class') },
        { name: this.$t('homework.subject') },
        { name: this.$t('homework.remark') },
        { name: this.$t('homework.notification') },
        { name: this.$t('homework.sendDate') },
        {
          name: this.$t('homework.answer'),
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('homework.getScore'),
          style: 'text-align:center; width:7%'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/teacherHomework/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('eschool/teacherHomework/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'homework-edit',
        params: { id: record.homework_id }
      })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'home/teacherHomework/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'home/teacherHomework/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    closeOpen(record) {
      this.homework_status_loading = true
      this.$store
        .dispatch('eschool/teacherHomework/changeStatus', {
          id: record.homework_id,
          data: {
            homework_status_id: record.homework_status_id
          }
        })
        .then(() => {
          record.status_open = record.status_open ? false : true
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.homework_status_loading = false
        })
    },
    onComment(record) {
      this.$router.push({
        name: 'homework-comment-public',
        params: { id: record.homework_id }
      })
    },
    sendNotification(record) {
      this.$confirm({
        title: this.$t('homework.confirmSend'),
        content:
          'All students and parents are going to see this homework and get notification',
        zIndex: 1020,
        okText: this.$t('yes'),
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch(
              'eschool/teacherHomework/sendNotification',
              record.homework_id
            )
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
            .finally(() => {
              record._deleting = false
            })
        },
        onCancel() {},
        class: 'test'
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
